import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export type ReloadToastOpener = () => Observable<boolean>;

export const RELOAD_TOAST = new InjectionToken<ReloadToastOpener>('RELOAD_TOAST', {
  providedIn: 'root',
  factory: (): ReloadToastOpener => () => of(false),
});
